import { render, staticRenderFns } from "./AppsVsWeb.vue?vue&type=template&id=dd08683c&"
import script from "./AppsVsWeb.vue?vue&type=script&lang=js&"
export * from "./AppsVsWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports